import api from "../../api.js";
import web from "../../web.js";

export default class PageOpsChangelog
{
    constructor(targetElement)
    {
        this.opName = targetElement.dataset.opname;
        const container = targetElement.querySelector("#changelog");
        if (container)
        {
            this.displayChangelog(container);
        }
    }

    displayChangelog(targetElement)
    {
        if (!targetElement) return;
        const errorBlock = ele.byId("changeLogError");
        if (errorBlock) ele.hide(errorBlock);
        const emptyBlock = ele.byId("changeLogEmpty");
        if (emptyBlock) ele.hide(emptyBlock);
        let apiUrl = "ops/changelog";
        if (this.opName) apiUrl += "/" + this.opName;
        const from = web.getQueryVariable("from") || 0;
        const to = web.getQueryVariable("to") || Date.now();
        const limit = web.getQueryVariable("l");
        const offset = web.getQueryVariable("o");
        apiUrl += "?from=" + from;
        apiUrl += "&to=" + to;
        apiUrl = web.tabs.addPagination(apiUrl, limit, offset);
        api.get(apiUrl, (res) =>
        {
            if (res && res.data && res.data.length > 0)
            {
                web.setHandleBarHtml("ops_changelog", { "changes": res.data }, targetElement);
                web.tabs.initPagination(targetElement, res.pagination);
            }
            else
            {
                targetElement.innerText = "";
                if (emptyBlock) ele.show(emptyBlock);
            }
        }, (e) =>
        {
            console.error("failed to load ops changelog", e);
            if (errorBlock)
            {
                let msg = e.msg;
                if (e.code === 503)
                {
                    msg = "You lack permissions to the requested namespace.";
                }
                errorBlock.innerText = "Failed to load changelog: " + msg;
                ele.show(errorBlock);
            }
            targetElement.innerText = "";
        });
    }
}
